import { render } from "./DmModal.vue?vue&type=template&id=482fdb10&scoped=true"
import script from "./DmModal.vue?vue&type=script&lang=js"
export * from "./DmModal.vue?vue&type=script&lang=js"

import "./DmModal.vue?vue&type=style&index=0&id=482fdb10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482fdb10"]])

export default __exports__